// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".choose-content[data-v-a8ddee8a] {\n  border-radius: 14px;\n}\n.item-container[data-v-a8ddee8a] {\n  margin-bottom: 30px;\n  cursor: pointer;\n}\n.item-title[data-v-a8ddee8a] {\n  font-size: 18px;\n  font-weight: bold;\n}\n.item-content[data-v-a8ddee8a] {\n  font-size: 16px;\n}", ""]);
// Exports
module.exports = exports;
